import { render } from "./CarouselCat.vue?vue&type=template&id=62a11d70&scoped=true"
import script from "./CarouselCat.vue?vue&type=script&lang=js"
export * from "./CarouselCat.vue?vue&type=script&lang=js"

import "./CarouselCat.vue?vue&type=style&index=0&id=62a11d70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a11d70"]])

export default __exports__